import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { DashboardBranchPerformanceResponseModel } from '@/types'

export const getDashboardBranchPerformance = async (
  branchName: string,
  startMonth: string,
  endMonth: string
): Promise<DashboardBranchPerformanceResponseModel> => {
  try {
    const response = await axios.get(
      `${BASE_URL}/dashboard/branch-performance`,
      {
        params: {
          start_month: startMonth,
          end_month: endMonth,
          branch_names: branchName,
        },
      }
    )

    return response.data
  } catch (error) {
    throw error
  }
}
